<template>
  <div>
    <div style="font-size: 14px;line-height: 40px;color: #606266;font-weight: 700">日期(Data)</div>
    <el-date-picker
      v-model="timeValue"
      :clearable="false"
      end-placeholder="结束时间（Hora de fim）"
      range-separator="-"
      start-placeholder="开始时间（Hora de início）"
      type="daterange"
      value-format="yyyy-MM-dd"
      style="margin-bottom: 20px" size="small"
      @change="dateChange"
    />
    <div style="margin-bottom: 20px">
      <el-button
        type="primary" plain size="small"
        @click="search"
      >查询(Consultar)</el-button>
      <el-button type="primary" size="small" @click="exportAll">导出(Exportar)</el-button>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border max-height="600" style="width: 100%"
      :summary-method="getSummaries"
    >
      <el-table-column
        type="index" prop="xuhao" label="序号(No.)"
        align="center" width="60"
      />
      <el-table-column
        v-for="(item, idx) in tableHeaderList"
        :key="idx"
        align="center"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'lostCount' || item.prop === 'damagedCount' || item.prop === 'lossCount' || item.prop === 'stolenCount'">
            <div
              v-if="scope.row[item.prop]"
              style="color: #1990ff;cursor: pointer"
              @click="toDetail(scope.row, item.prop)"
            >
              {{ scope.row[item.prop] }}
            </div>
            <span v-else>--</span>
          </div>
          <div v-else :style="{ fontWeight: scope.row.isSummary && item.prop !== 'xuhao' ? 'bold' : 'normal' }">
            {{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { hub1Page, hub1Export } from '@/api/orderApi';
import dayjs from 'dayjs';
import { goRWExportList } from '@/utils/goExportList';

export default {
  data() {
    return {
      timeValue: [],
      tableData: [],
      queryForm: {},
      tableHeaderList: [
        { label: '日期(Data)', prop: 'statisticDate', cloWidth: '120' },
        { label: '入库量(Qtd. de entrada)', prop: 'inboundCount', cloWidth: '150' },
        { label: '丢件量(Qtd. de extravio)', prop: 'lostCount', cloWidth: '150' },
        { label: '破损量(Qtd. de itens avariados)', prop: 'damagedCount', cloWidth: '150' },
        { label: '被盗/被抢量(Qtd. de roubo)', prop: 'stolenCount', cloWidth: '150' },
        { label: '丢损量(Qtd. de extravio e avaria)', prop: 'lossCount', cloWidth: '150' },
        { label: '丢件率(Taxa de extravio)', prop: 'lostRate', cloWidth: '150' },
        { label: '破损率(Taxa de avaria)', prop: 'damagedRate', cloWidth: '150' },
        { label: '被盗或被抢率(Taxa de roubo)', prop: 'stolenRate', cloWidth: '150' },
        { label: '丢损率(Taxa de extravio e avaria)', prop: 'lossRate', cloWidth: '150' }
      ]
    };
  },
  created() {
    this.default();
    this.search();
  },
  methods: {
    default() {
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo, today];
      this.queryForm = {
        startDate: oneWeekAgo,
        endDate: today
      };
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm = {
          startDate: '',
          endDate: ''
        };
        return;
      }
      this.queryForm = {
        startDate: val[0],
        endDate: val[1]
      };
      // 调用查询
      this.search();
    },
    search() {
      if (this.queryForm.startDate && this.queryForm.endDate) {
        hub1Page(this.queryForm).then(res => {
          if (res.code === 200) {
            const summaryRow = this.calculateSummary(res.data);
            summaryRow.isSummary = true; // 汇总行
            // 将汇总行插入到数据第一行
            this.tableData = [summaryRow, ...res.data];
          }
        });
      } else {
        this.$message.warning(this.$t('collectionCenter.selectDate'));
      }
    },
    // 计算汇总数据的方法
    calculateSummary(data) {
      if (!data || data.length === 0) {
        return {};
      }
      // 获取日期范围
      const dates = data.map(item => item.statisticDate).filter(date => date);
      const sortedDates = dates.sort();
      const dateRange = `${sortedDates[0]}~${sortedDates[sortedDates.length - 1]}`;

      // 计算各列汇总值
      const inboundCount = data.reduce((sum, item) => sum + (item.inboundCount || 0), 0);
      const lostCount = data.reduce((sum, item) => sum + (item.lostCount || 0), 0);
      const damagedCount = data.reduce((sum, item) => sum + (item.damagedCount || 0), 0);
      const lossCount = data.reduce((sum, item) => sum + (item.lossCount || 0), 0);
      const stolenCount = data.reduce((sum, item) => sum + (item.stolenCount || 0), 0);

      const lostRate = inboundCount !== 0 ? ((lostCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const damagedRate = inboundCount !== 0 ? ((damagedCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const stolenRate = inboundCount !== 0 ? ((stolenCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const lossRate = inboundCount !== 0 ? ((lossCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const summary = {
        statisticDate: dateRange,
        inboundCount,
        lostCount,
        damagedCount,
        lossCount,
        stolenCount,
        lostRate,
        damagedRate,
        stolenRate,
        lossRate
      };
      return summary;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          // 第一列显示日期范围
          if (data && data.length > 0) {
            const dates = data.map(item => item.statisticDate).filter(date => date);
            if (dates.length > 0) {
              const sortedDates = dates.sort();
              sums[index] = `${sortedDates[0]}~${sortedDates[sortedDates.length - 1]}`;
            } else {
              sums[index] = ' -- ';
            }
          } else {
            sums[index] = ' -- ';
          }
        } else {
          // 其余列计算数值总和
          const values = data.map(item => Number(item[column.property]));
          const sum = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          // 对于比率列，可能需要特殊处理，这里根据实际情况调整
          if (column.property.includes('Rate')) {
            sums[index] = data.length > 0 ? (sum / data.length).toFixed(2) + '%' : '0%';
          } else {
            sums[index] = isNaN(sum) ? ' -- ' : sum;
          }
        }
      });
      return sums;
    },
    exportAll() {
      hub1Export(this.queryForm).then(res => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },
    toDetail(row, type) {
      // 丢损类型: 1=确认丢失, 2=被偷或被抢, 3=破损
      const typeVal = type === 'lostCount' ? [1] : type === 'damagedCount' ? [3] : type === 'lossCount' ? [1, 2, 3] : type === 'stolenCount' ? [2] : null;
      let startDate = '';
      let endDate = '';
      if (row.statisticDate.includes('~')) {
        [startDate, endDate] = row.statisticDate.split('~');
      } else {
        startDate = row.statisticDate;
        endDate = row.statisticDate;
      }
      this.$emit('detailData', startDate + ' 00:00:00', endDate + ' 23:59:59', 1, typeVal, null, null);
    }
  }
};
</script>

<style lang="scss" scoped>
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
